import script from "./FieldDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./FieldDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./FieldDrawer.vue?vue&type=style&index=0&id=6904ab36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6904ab36"]])

export default __exports__